export default "__VITE_ASSET__3a94f4ed__"